import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { getTypographyStyles } from '../Typography/Typography.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Modal = styled.dialog(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: none;\n  color: ", ";\n  padding: 0;\n\n  &::backdrop {\n    background: ", ";\n    opacity: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colours.ink.primary.main;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colours.layering[0].strong;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.opacity.overlay;
});
var headerHeight = 3.5;
var footerHeight = 4;
var ModalHeader = styled(getTypographyStyles('headingRegular'))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  line-height: ", ";\n  padding: ", ";\n  border-bottom: ", ";\n  width: 100%;\n  color: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizing.large;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sizing.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colours.ink.primary.main;
});
var ModalContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: ", ";\n  min-width: 21.875rem;\n  max-width: 90vw;\n  max-height: calc(90vh - ", "rem);\n  overflow-y: auto;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.medium;
}, headerHeight + footerHeight);
var ModalFooter = styled.footer(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 0.625rem;\n  padding: ", ";\n  border-top: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.sizing.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main);
});

export { Modal, ModalContent, ModalFooter, ModalHeader };
//# sourceMappingURL=Modal.styles.js.map
